import { t } from "@lingui/macro";
import graphql from "babel-plugin-relay/macro";
import { Image } from "react-native";
import { useFragment } from "react-relay";

import { getThumbnail } from "@whoosh/utilities/src/Cloudinary";

import { ClubLogoNotificationsFragment_session$key } from "./__generated__/ClubLogoNotificationsFragment_session.graphql";

export const ClubLogo = ({
  sessionRef,
}: {
  sessionRef: ClubLogoNotificationsFragment_session$key | null;
}) => {
  const session = useFragment(ClubLogoFragmentString, sessionRef);
  const clubLogoPublicId =
    session?.currentClientProfile?.member?.club.logoImage?.publicId;
  return (
    <Image
      source={{
        uri: getThumbnail(clubLogoPublicId, 55, 55)?.toURL(),
      }}
      accessibilityLabel={t`Club Logo`}
      style={{
        width: 40,
        height: 40,
        borderRadius: 6,
      }}
    />
  );
};

export const ClubLogoFragmentString = graphql`
  fragment ClubLogoNotificationsFragment_session on Session {
    currentClientProfile {
      member {
        club {
          logoImage {
            # TODO(ENG-3436): Remove the publicId alias when legacy image props are retired.
            publicId: renderingKey
          }
        }
      }
    }
  }
`;
